import { FeatureEntitlementName } from '@jupiterone/entitlement-types';
import { useABAC } from '@jupiterone/jupiter-web-toolkit/src';
import { APPS, APP_ACCESS_PERMISSIONS, JupiterOneApps } from '../constants';
import { useEntitlements } from '../entitlements';
import { HeadBarConfig } from '../types';

export default function useAvailableApps(): HeadBarConfig[] {
  const { enforce } = useABAC();
  const { entitlementEnforce } = useEntitlements();

  const hasRbacAndQueryPermissionsEntitlement = entitlementEnforce(
    FeatureEntitlementName.RBAC_AND_QUERY_PERMISSIONS
  );
  const ASSETS_PERMISSIONS = APP_ACCESS_PERMISSIONS[JupiterOneApps.Assets];
  const INSIGHTS_PERMISSIONS = APP_ACCESS_PERMISSIONS[JupiterOneApps.Insights];
  const MY_SECURITY_PERMISSIONS =
    APP_ACCESS_PERMISSIONS[JupiterOneApps.MySecurity];
  const COMPLIANCE_PERMISSIONS =
    APP_ACCESS_PERMISSIONS[JupiterOneApps.Compliance];
  const RULES_PERMISSIONS = APP_ACCESS_PERMISSIONS[JupiterOneApps.Rules];
  const LANDING_PERMISSIONS = APP_ACCESS_PERMISSIONS[JupiterOneApps.Landing];
  const GALAXY_PERMISSIONS = APP_ACCESS_PERMISSIONS[JupiterOneApps.Galaxy];
  const POLICIES_PERMISSIONS = APP_ACCESS_PERMISSIONS[JupiterOneApps.Policies];

  const withAssets = hasRbacAndQueryPermissionsEntitlement
    ? enforce(ASSETS_PERMISSIONS)
    : true;
  const withInsights = hasRbacAndQueryPermissionsEntitlement
    ? enforce(INSIGHTS_PERMISSIONS)
    : true;
  const withMySecurity = hasRbacAndQueryPermissionsEntitlement
    ? enforce(MY_SECURITY_PERMISSIONS)
    : true;
  const withCompliance = hasRbacAndQueryPermissionsEntitlement
    ? enforce(COMPLIANCE_PERMISSIONS)
    : true;
  const withRules = hasRbacAndQueryPermissionsEntitlement
    ? enforce(RULES_PERMISSIONS)
    : true;
  const withLanding = hasRbacAndQueryPermissionsEntitlement
    ? enforce(LANDING_PERMISSIONS)
    : true;
  const withGalaxy = hasRbacAndQueryPermissionsEntitlement
    ? enforce(GALAXY_PERMISSIONS)
    : true;
  const withPolicies = hasRbacAndQueryPermissionsEntitlement
    ? enforce(POLICIES_PERMISSIONS)
    : true;

  return APPS({
    withInsights,
    withMySecurity,
    withAssets,
    withCompliance,
    withGalaxy,
    withLanding,
    withRules,
    withPolicies,
  });
}
